export const epContactInfo = {
    whatsapp: "5521992850637",
    telefone: "(21) 99285-0637",
    instagram: "https://www.instagram.com/prof.iasmynlouis",
    facebook: "https://www.facebook.com/people/Escrita-Pr%C3%A1tica-Professora-Iasmyn-Souza-Louis/61595443131001/",
    superprof: "https://www.superprof.com.br/vai-fazer-enem-vestibular-concurso-sua-nota-redacao-pode-ser-diferencial-para-aprovacao-chegou-hora.html",
    email: `metodoescritapratica@gmail.com`,
    youtube: "https://www.youtube.com/@escritapratica",
};